document.addEventListener('DOMContentLoaded', () => {
    const sectionElement = document.querySelector('.pdp-section');
    if (!sectionElement) return;

    const sectionId = sectionElement.getAttribute('data-section');
    
    initGallery();
    initVariantPicker(sectionId);
    initBundles(sectionId);
});

// 1. IMAGE GALLERY (Thumbnail Clicks)
function initGallery() {
    const thumbnails = document.querySelectorAll('.pdp-thumb, .pdp-grid-img');
    if (!document.getElementById('pdpMain') || !thumbnails.length) return;

    thumbnails.forEach(thumb => {
        thumb.addEventListener('click', function() {
            // Look the photo up on every tap: a variant change replaces the main
            // photo element, and a reference kept from page load points at the old,
            // detached one, so thumbnail taps silently did nothing after a color tap.
            const mainImg = document.getElementById('pdpMain');
            if (!mainImg) return;
            document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
            this.classList.add('active');

            const newSrc = this.getAttribute('data-main-img');
            mainImg.style.opacity = '0.5';
            setTimeout(() => {
                mainImg.setAttribute('src', newSrc);
                mainImg.setAttribute('alt', (this.querySelector('img') || {}).alt || '');
                mainImg.style.opacity = '1';
            }, 150);

            // On a phone the big photo is often scrolled partly off screen; bring it
            // into view so the shopper sees it change (below the fixed header).
            // scroll-margin-top on #pdpMain (main-product-aw) keeps it clear of the
            // fixed ribbon and header.
            if (window.matchMedia('(max-width: 991.98px)').matches) {
                const rootCss = getComputedStyle(document.documentElement);
                const header = (parseInt(rootCss.getPropertyValue('--aw-mobile-header-height')) || 60)
                    + (parseInt(rootCss.getPropertyValue('--aw-ribbon-h')) || 0);
                if (mainImg.getBoundingClientRect().top < header) {
                    mainImg.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });
    });
}

// 2. VARIANT SELECTION (Dynamic Fetching)
function initVariantPicker(sectionId) {
    const productJsonEl = document.getElementById(`ProductJson-${sectionId}`);
    if(!productJsonEl) return;
    
    const productData = JSON.parse(productJsonEl.innerHTML);

    // Tapping a size or color that is already chosen fires no change event, so
    // it looked dead and people tapped it again and again. Give it a small bump.
    document.addEventListener('click', (event) => {
        const label = event.target.closest('label.btn-pdp-pill, label.sw-sq');
        if (!label) return;
        const input = document.getElementById(label.getAttribute('for'));
        if (!input || !input.checked) return;
        [label, document.getElementById(`AwPick-${sectionId}`)].forEach(el => {
            if (!el) return;
            el.classList.remove('aw-bump');
            void el.offsetWidth;
            el.classList.add('aw-bump');
        });
    });

    syncAvailability(productData);

    document.addEventListener('change', (event) => {
        if (!event.target.classList.contains('variant-input')) return;

        const input = event.target;
        
        // --- A. Update UI Classes ---
        const wrapper = input.closest('.variant-wrapper');
        const labels = wrapper.querySelectorAll('label');
        
        labels.forEach(label => {
            label.classList.remove('active');
            const checkIcon = label.querySelector('.fa-check');
            if(checkIcon) checkIcon.classList.add('d-none');
        });

        const selectedLabel = wrapper.querySelector(`label[for="${input.id}"]`);
        if (selectedLabel) {
            selectedLabel.classList.add('active');
            const checkIcon = selectedLabel.querySelector('.fa-check');
            if(checkIcon) checkIcon.classList.remove('d-none');
        }

        // Socks on phones: the color swatches under the photo are labels for these
        // same inputs, outside this wrapper. Mirror the selected state there.
        document.querySelectorAll(`input[name="${CSS.escape(input.name)}"]`).forEach(other => {
            document.querySelectorAll(`.aw-photo-swatch[for="${other.id}"]`).forEach(lab => {
                const on = other === input;
                lab.classList.toggle('active', on);
                const icon = lab.querySelector('.fa-check');
                if (icon) icon.classList.toggle('d-none', !on);
            });
        });
        if (document.querySelector(`.aw-photo-swatch[for="${input.id}"]`)) {
            const nameEl = document.querySelector('[data-aw-color-name]');
            if (nameEl) nameEl.textContent = input.value;
        }

        // A pick that makes a combination that doesn't exist (Green / XXL) used to
        // light the button while the form kept the old variant, so the cart got a
        // different size than the one shown. Move the other choices to the closest
        // combination that exists; the re-fired change finishes the update.
        if (fixImpossiblePick(productData, input)) return;

        // --- B. Find Selected Variant Data ---
        const selectedOptions = Array.from(document.querySelectorAll('.variant-input:checked')).map(el => el.value);
        const matchedVariant = productData.variants.find(variant => {
            return variant.options.every((opt, i) => opt === selectedOptions[i]);
        });

        syncAvailability(productData);

        if (matchedVariant) {
            updatePickCard(sectionId, productData, matchedVariant);
            swapMainPhotoNow(sectionId, matchedVariant, input);
            // Update hidden ID
            document.getElementById(`VariantId-${sectionId}`).value = matchedVariant.id;
            // Seamlessly update browser URL
            window.history.replaceState({}, '', `${window.location.pathname}?variant=${matchedVariant.id}`);
            
            // --- C. Re-render Shopify blocks via API ---
            fetch(`${window.location.pathname}?variant=${matchedVariant.id}&section_id=${sectionId}`)
                .then(res => res.text())
                .then(html => {
                    const newDoc = new DOMParser().parseFromString(html, 'text/html');
                    
                    // 1. Update Price, Inventory, Buttons
                    ['Price', 'Inventory', 'BuyButtons'].forEach(block => {
                        const elId = `${block}-${sectionId}`;
                        if(document.getElementById(elId) && newDoc.getElementById(elId)) {
                            document.getElementById(elId).innerHTML = newDoc.getElementById(elId).innerHTML;
                        }
                    });

                    // 2. Update Main Image directly from fetched HTML
                    const imageWrapperId = `ProductImageWrapper-${sectionId}`;
                    const currentImgWrapper = document.getElementById(imageWrapperId);
                    const newImgWrapper = newDoc.getElementById(imageWrapperId);
                    
                    // A free gift choice ("Free Sock Size") never changes which product photo is shown,
                    // and the free gift box pre-selects Large on load, so it must not replace the
                    // main picture (the poster bundle leads with its "8 POSTER DESIGNS" picture).
                    const changedFreeGift = /free/i.test(input.name || '');
                    // Same photo (every size of one color shares it): leave it alone.
                    // Compared by file name: the photo may already have been swapped from
                    // the product JSON (cdn.shopify.com URL) before this reply (/cdn/shop URL).
                    const photoPath = (wrap) => {
                        const img = wrap && wrap.querySelector('img');
                        return img ? (img.getAttribute('src') || '').split('?')[0].split('/').pop() : '';
                    };
                    const samePhoto = photoPath(currentImgWrapper) !== '' && photoPath(currentImgWrapper) === photoPath(newImgWrapper);
                    if(currentImgWrapper && newImgWrapper && !changedFreeGift && !samePhoto) {
                        const mainImg = currentImgWrapper.querySelector('img');
                        if(mainImg) mainImg.style.opacity = '0.5';

                        setTimeout(() => {
                            // Hold the photo's height while the new one loads. Without this the
                            // box collapsed for a moment and everything below (sizes, packs,
                            // Add to Cart) jumped up ~350 px and back on every size tap
                            // (layout shift 1.3 on a phone, 2026-11-01).
                            currentImgWrapper.style.minHeight = currentImgWrapper.offsetHeight + 'px';
                            currentImgWrapper.innerHTML = newImgWrapper.innerHTML;
                            const newImg = currentImgWrapper.querySelector('img');
                            const release = () => { currentImgWrapper.style.minHeight = ''; };
                            if (newImg && !newImg.complete) {
                                newImg.loading = 'eager';
                                newImg.addEventListener('load', release, { once: true });
                                newImg.addEventListener('error', release, { once: true });
                                setTimeout(release, 4000);
                            } else {
                                release();
                            }

                            // Highlight the matching thumbnail visually
                            if (matchedVariant.featured_media) {
                                document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
                                const targetThumb = document.querySelector(`[data-media-id="${matchedVariant.featured_media.id}"]`);
                                if (targetThumb) targetThumb.classList.add('active');
                            }
                        }, 150);
                    }
                    
                    // 3. Recalculate Bundles
                    updateBundleMath(matchedVariant.price);
                });
        }
    });
}

// Socks: the "Your pick" card above the color and size buttons. Updated at
// once from the product JSON (no network wait), so the shopper sees the sock
// change right where they tap.
function updatePickCard(sectionId, productData, variant) {
    const card = document.getElementById(`AwPick-${sectionId}`);
    if (!card) return;
    const names = (productData.options || []).map(o => (typeof o === 'string' ? o : o.name || '').toLowerCase());
    const value = (test) => {
        const i = names.findIndex(test);
        return i >= 0 ? variant.options[i] : '';
    };
    const color = value(n => n.includes('color') || n.includes('colour'));
    const size = value(n => n.includes('size'));

    const nameEl = card.querySelector('[data-aw-pick-name]');
    if (nameEl) nameEl.textContent = [color, size].filter(Boolean).join(' · ');

    const fits = {};
    (card.dataset.fits || '').split('|').forEach(pair => {
        const [k, v] = pair.split(':');
        if (k && v) fits[k.trim()] = v.trim();
    });
    const fitEl = card.querySelector('[data-aw-pick-fit]');
    if (fitEl) fitEl.textContent = fits[size] ? `${card.dataset.fitLabel || ''} ${fits[size]}`.trim() : '';

    const img = card.querySelector('.aw-pick__img');
    const src = variant.featured_image && variant.featured_image.src;
    if (img && src) {
        const next = src.replace(/^\/\//, 'https://') + (src.includes('?') ? '&' : '?') + 'width=240';
        if (img.getAttribute('src').split('?')[0] !== next.split('?')[0]) {
            img.style.opacity = '0.4';
            const pre = new Image();
            pre.onload = pre.onerror = () => { img.src = next; img.style.opacity = '1'; };
            pre.src = next;
        }
    }
}

// Option groups in product order: [{ name, inputs: [...] }, ...]
function optionGroups(productData) {
    const names = (productData.options || []).map(o => (typeof o === 'string' ? o : o.name));
    return names.map(name => ({
        name,
        inputs: Array.from(document.querySelectorAll('.variant-input')).filter(i => i.name === `options[${name}]`)
    }));
}

// Cross out the choices that make no buyable combination with the other current
// choices (e.g. XXL once Green is picked). They stay tappable: tapping one moves
// the other choices to match (fixImpossiblePick). Labels for the same input (the
// swatches under the photo) follow along.
function syncAvailability(productData) {
    const groups = optionGroups(productData);
    if (groups.length < 2 || groups.some(g => !g.inputs.length)) return;
    const selected = groups.map(g => (g.inputs.find(i => i.checked) || {}).value);
    groups.forEach((g, gi) => {
        g.inputs.forEach(inp => {
            const want = selected.slice();
            want[gi] = inp.value;
            const ok = productData.variants.some(v => v.available && v.options.every((o, k) => o === want[k]));
            document.querySelectorAll(`label[for="${inp.id}"]`).forEach(l => {
                l.classList.toggle('aw-unavailable', !ok);
                l.setAttribute('aria-disabled', ok ? 'false' : 'true');
            });
        });
    });
}

// If the input just picked leaves no matching buyable variant, switch the other
// options to the closest available variant that keeps this pick (preferring the
// shopper's current choices in product order) and re-fire change. Returns true
// when it did so.
function fixImpossiblePick(productData, input) {
    const groups = optionGroups(productData);
    const gi = groups.findIndex(g => g.inputs.includes(input));
    if (gi < 0) return false;
    const selected = groups.map(g => (g.inputs.find(i => i.checked) || {}).value);
    const exact = productData.variants.find(v => v.options.every((o, k) => o === selected[k]));
    if (exact && exact.available) return false;

    const candidates = productData.variants.filter(v => v.available && v.options[gi] === input.value);
    if (!candidates.length) return false;
    const score = (v) => v.options.reduce((s, o, k) => s + (o === selected[k] ? (k === gi ? 0 : 10 - k) : 0), 0);
    const best = candidates.slice().sort((a, b) => score(b) - score(a))[0];

    let changed = null;
    groups.forEach((g, k) => {
        if (k === gi) return;
        const target = g.inputs.find(i => i.value === best.options[k]);
        if (target && !target.checked) {
            target.checked = true;
            changed = target;
        }
    });
    if (!changed) return false;
    changed.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
}

// Swap the big photo straight from the product JSON when a color is tapped, so
// it changes in view right away instead of after the section reply. Socks only
// (the swatches under the photo); the free gift size choice never moves it.
function swapMainPhotoNow(sectionId, variant, input) {
    if (!document.querySelector('[data-aw-photo-swatches]')) return;
    if (/free/i.test(input.name || '')) return;
    const img = document.getElementById('pdpMain');
    const src = variant.featured_image && variant.featured_image.src;
    if (!img || !src) return;
    const file = (u) => (u || '').split('?')[0].split('/').pop();
    if (file(img.getAttribute('src')) === file(src)) return;
    const next = src.replace(/^\/\//, 'https://') + (src.includes('?') ? '&' : '?') + 'width=1200';
    const wrap = document.getElementById(`ProductImageWrapper-${sectionId}`);
    if (wrap) wrap.style.minHeight = wrap.offsetHeight + 'px';
    img.style.opacity = '0.6';
    const pre = new Image();
    pre.onload = pre.onerror = () => {
        img.src = next;
        img.alt = (variant.featured_media && variant.featured_media.alt) || variant.name || '';
        img.style.opacity = '1';
        if (wrap) wrap.style.minHeight = '';
    };
    pre.src = next;
    if (variant.featured_media) {
        document.querySelectorAll('.pdp-thumb, .pdp-grid-img').forEach(t => t.classList.remove('active'));
        const thumb = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
        if (thumb) thumb.classList.add('active');
    }
}

// 3. SOCK PACKS (1 / 3 / 6 pairs)
// The 10% (3+) and 20% (6+) discounts are automatic in the cart; this only
// shows them. Add to Cart lives in BuyButtons, which is re-rendered on every
// variant change, so its price is re-applied after each render, never cached.
let awPackPriceCents = null;

const awFormatMoney = (cents) => '$' + (cents / 100).toFixed(2);
const awPackPercent = (qty) => (qty >= 6 ? 20 : qty >= 3 ? 10 : 0);
// Shopify takes the percentage off each pair and rounds it down to the cent
// (20% of $12.49 = $2.49 off, so $10.00 a pair). Match it exactly.
const awPairPrice = (cents, pct) => cents - Math.floor(cents * pct / 100);
const awSectionId = () => {
    const el = document.querySelector('.pdp-section');
    return el ? el.getAttribute('data-section') : null;
};

function initBundles(sectionId) {
    const bundles = document.querySelectorAll('.bundle-card');
    if (!bundles.length) return;
    const qtySelect = document.getElementById(`Quantity-${sectionId}`);

    const initialPriceEl = document.getElementById(`Price-${sectionId}`);
    if (initialPriceEl) {
        const cents = Math.round(parseFloat(initialPriceEl.innerText.replace(/[^0-9.]/g, '')) * 100);
        if (!isNaN(cents)) updateBundleMath(cents);
    }

    const select = (card) => {
        bundles.forEach(b => {
            const on = b === card;
            b.classList.toggle('active', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
    };

    bundles.forEach(bundle => {
        const choose = () => {
            select(bundle);
            if (qtySelect) qtySelect.value = bundle.getAttribute('data-qty');
            updateAtcPrice(sectionId);
        };
        bundle.addEventListener('click', choose);
        bundle.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); }
        });
    });

    if (qtySelect) {
        const sync = () => {
            const val = parseInt(qtySelect.value) || 1;
            const card = document.querySelector(`.bundle-card[data-qty="${val >= 6 ? 6 : val >= 3 ? 3 : 1}"]`);
            if (card) select(card);
            updateAtcPrice(sectionId);
        };
        qtySelect.addEventListener('change', sync);
        qtySelect.addEventListener('input', sync);
        // The - / + buttons change the value without firing an event.
        document.querySelectorAll('.qty-btn').forEach(b => b.addEventListener('click', () => setTimeout(sync, 0)));
    }

    // BuyButtons is replaced wholesale on variant change: watch the container.
    const container = document.getElementById(`BuyButtons-${sectionId}`);
    if (container && 'MutationObserver' in window) {
        new MutationObserver(() => updateAtcPrice(sectionId)).observe(container, { childList: true });
    }

    // ?pack=6 (from the six-pack card on the Socks page) opens on that pack.
    // Without it the page keeps its default (the 3-Pack).
    const wantPack = parseInt(new URLSearchParams(location.search).get('pack'), 10);
    if (wantPack) {
        const packCard = document.querySelector(`.bundle-card[data-qty="${wantPack}"]`);
        if (packCard) packCard.click();
    }
    updateAtcPrice(sectionId);
}

function updateAtcPrice(sectionId) {
    if (awPackPriceCents === null || !document.querySelector('.bundle-card')) return;
    const qtySelect = document.getElementById(`Quantity-${sectionId}`);
    const btnPrice = document.querySelector(`#AddToCartBtn-${sectionId} .btn-price`);
    if (!btnPrice) return;
    const qty = Math.max(1, parseInt(qtySelect && qtySelect.value) || 1);
    const total = awPairPrice(awPackPriceCents, awPackPercent(qty)) * qty;
    const text = qty > 1 ? `${qty} for ${awFormatMoney(total)}` : awFormatMoney(total);
    if (btnPrice.textContent.trim() !== text) btnPrice.textContent = text;
}

function updateBundleMath(priceInCents) {
    awPackPriceCents = priceInCents;
    document.querySelectorAll('.bundle-card').forEach(card => {
        const qty = parseInt(card.getAttribute('data-qty'));
        const pct = parseInt(card.getAttribute('data-discount') || 0);
        if (qty === 1) {
            const priceEl = card.querySelector('.bundle-price');
            if (priceEl) priceEl.textContent = awFormatMoney(priceInCents);
            return;
        }
        const perPair = card.querySelector('.bundle-price-discounted');
        const compare = card.querySelector('.bundle-compare-price');
        const total = card.querySelector('.bundle-total');
        if (perPair) perPair.innerHTML = `${awFormatMoney(awPairPrice(priceInCents, pct))}<small>/pair</small>`;
        if (compare) compare.textContent = awFormatMoney(priceInCents * qty);
        if (total) total.textContent = awFormatMoney(awPairPrice(priceInCents, pct) * qty);
    });
    const sectionId = awSectionId();
    if (sectionId) updateAtcPrice(sectionId);
}